import { execForm } from '../utils/exec';
import { getApiToken } from '../utils/tokenExchange';
import type {
  UpdateVariantSkuDetailsArgs,
  UpdateVariantSkuDetailsExecVariables,
  UpdateVariantSkuDetailsExecResponse,
  VariantDetails,
} from '@src/types/catalog';

/**
 * Updates detailed information for a specific variant SKU
 * Supports file uploads for images
 * @param args - Contains token, partnerCode, sku, and update fields including optional files
 * @returns Promise resolving to updated variant details
 */
export const updateVariantSkuDetails = async (
  args: UpdateVariantSkuDetailsArgs
): Promise<VariantDetails> => {
  const { token: rawToken, partnerCode, sku, files = {}, imageKeys = [], ...updateFields } = args;
  const token = await getApiToken(rawToken);

  const mutation = `
    mutation updateVariantSkuDetails(
      $sku: String!
      $partnerCode: String!
      $token: String!
      $upc: [String]
      $mpn: [String]
      $gtin: [String]
      $partnerSku: [String!]
      $partnerParentSku: [String!]
      $family: JSON
      $data: JSON
      $imageKeys: [String!]
    ) {
      restUser(token: $token) {
        partner(code: $partnerCode) {
          updateVariantSkuDetails(
            sku: $sku
            upc: $upc
            mpn: $mpn
            gtin: $gtin
            partnerSku: $partnerSku
            partnerParentSku: $partnerParentSku
            family: $family
            data: $data
            imageKeys: $imageKeys
          ) {
            upc
            mpn
            gtin
            partnerSku
            partnerParentSku
            family
            data
            partnerImageUrls
          }
        }
      }
    }
  `;

  const variables: UpdateVariantSkuDetailsExecVariables = {
    token,
    partnerCode,
    sku,
    ...updateFields,
    imageKeys,
  };

  const data = await execForm<UpdateVariantSkuDetailsExecVariables, UpdateVariantSkuDetailsExecResponse>(
    mutation,
    variables,
    files
  );

  return data.restUser.partner.updateVariantSkuDetails;
};
